import { Injectable } from '@angular/core';

import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

import { ContextCourtModel, EnumerationModel } from '@bayclubs/court-booking-employee-api';
import { BcStateListContext, Spinner } from '@bayclubs/state';
import { utils } from '@bayclubs/ui-core';

import { BlockedSlotSaveInputModel } from '../models/blocked-slot-save-input.model';
import * as actions from './blocked-slot-save.actions';
import { BlockedSlotSaveSelectors } from './blocked-slot-save.selectors';

@Injectable({ providedIn: 'root' })
export class BlockedSlotSaveFacade {
    @Select(BlockedSlotSaveSelectors.getSpinner) spinner$: Observable<Spinner>;
    @Select(BlockedSlotSaveSelectors.isFormValid) isFormValid$: Observable<boolean>;
    @Select(BlockedSlotSaveSelectors.clubCourts) clubCourts$: Observable<BcStateListContext<ContextCourtModel>>;
    @Select(BlockedSlotSaveSelectors.blockedSlotTypes) blockedSlotTypes$: Observable<BcStateListContext<EnumerationModel>>;
    @Select(BlockedSlotSaveSelectors.isDateSelected) isDateSelected$: Observable<boolean>;
    @Select(BlockedSlotSaveSelectors.showSpinner) showSpinner$: Observable<boolean>;


    constructor(private store: Store) { }

    loadForm = (input: BlockedSlotSaveInputModel) => this.store.dispatch(new actions.LoadFormAction(input));
    saveBlockedSlot = () => this.store.dispatch(new actions.SaveBlockedSlotAction());
    clearSaveForm = () => this.store.dispatch(new actions.ClearSaveFormAction());
    loadCourts = (clubId: string = null, date: utils.BcDate = null) => this.store.dispatch(new actions.LoadCourtsAction(clubId, date));
}
